import React, { useEffect, useRef } from "react";
import { authFetch, BILLING_API_URL, SITE } from "../../utils/auth";
import OnboardingComplete from '../onboarding/OnboardingComplete';

export default function ConnectSuccess() {
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    async function completeStripe() {
      try {
        const res = await authFetch(
          `${BILLING_API_URL}/connect/stripe/complete/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Site": SITE,
            },
          }
        );

        console.log("Stripe complete status:", res.status);

        await res.json();

      } catch (err) {
        console.error("Stripe completion failed:", err);
      }
    }

    completeStripe();
  }, []);

  return <OnboardingComplete completed={true} />;
}